// Active tracer. Feature code imports `tracer` from `@core/observability` —
// it gets whichever implementation is registered. Defaults to the no-op so
// every call site is safe before `initObservability()` runs (or when
// running without a real OTel exporter).
//
// To activate real OTel:
//   1. yarn add @opentelemetry/api @opentelemetry/sdk-trace-web
//      @opentelemetry/instrumentation-fetch @opentelemetry/exporter-trace-otlp-http
//   2. Build an OTel-backed Tracer in this file (wrap @opentelemetry/api).
//   3. Call `setTracer(otelTracer)` from `app/bootstrap/initObservability.ts`.
// No call site changes.

import { noopTracer } from './noopTracer'
import type { Tracer } from './tracerTypes'

let activeTracer: Tracer = noopTracer

export const tracer = new Proxy({} as Tracer, {
  get(_target, prop: keyof Tracer) {
    return activeTracer[prop]
  },
}) as Tracer

// Bootstrap-only — swaps the active tracer. Calling this after the app has
// started running is supported (idempotent), but most teams set it once
// during bootstrap and never touch it again.
export const setTracer = (impl: Tracer): void => {
  activeTracer = impl
}
